export default [
  {
    path: '/popup/:name/:id?',
    name: 'detailPopup',
    component: () => import('@/pages/DetailPopup.vue'),
    meta: {
      rule: 'editor',
    },
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/pages/500.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/pages/403.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/pages/home/HomePage.vue'),
  },
  {
    path: '/login-callback',
    name: 'LoginCallback',
    component: () => import('@/pages/LoginCallback.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/switch-organization',
    name: 'SwitchOrganization',
    component: () => import('@/pages/SwitchOrganization.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/two-factor-auth-login',
    name: 'TwoFactorAuthLogin',
    component: () => import('@/pages/TwoFactorAuthLogin.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/app-choosen/:appcode',
    name: 'AppChoosen',
    component: () => import(
      /* webpackChunkName: "app-choosen" */
      /* webpackPrefetch: true */
      '@/pages/derivery-app/DeriveryApp.vue'
    ),
    meta: {},
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import(/* webpackChunkName:'logout'*/ '@/pages/Logout.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/confirmRedirect',
    name: 'confirm-redirect',
    component: () => import(/* webpackChunkName:'demo'*/ '@/pages/ConfirmRedirect.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/pages/PrivacyPage.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/terms-privacy',
    name: 'TermsPrivacy',
    component: () => import('@/pages/PrivacyTermsSecond.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/choose-tenant',
    name: 'ChooseTenant',
    component: () => import('@/pages/ChooseTenantView.vue'),
    meta: {
    },
  },
  {
    path: '/pre-auth-choose-tenant',
    name: 'PreAuthChooseTenant',
    component: () => import('@/pages/PreAuthChooseTenant.vue'),
    meta: { anonymous: true },
  },
  // {
  //   path: '/bi/',
  //   name: 'bi',
  //   component: () => import(/* webpackChunkName:'demo'*/ '@/pages/PowerBi.vue'),
  //   meta: {
  //     anonymous: true,
  //   },
  // }
];
